/* eslint-disable max-len */
import * as React from "react";

const Profile: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM5.07 16.28C5.5 15.38 8.12 14.5 10 14.5C11.88 14.5 14.51 15.38 14.93 16.28C13.57 17.36 11.86 18 10 18C8.14 18 6.43 17.36 5.07 16.28ZM16.36 14.83C14.93 13.09 11.46 12.5 10 12.5C8.54 12.5 5.07 13.09 3.64 14.83C2.62 13.49 2 11.82 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 11.82 17.38 13.49 16.36 14.83ZM10 4C8.06 4 6.5 5.56 6.5 7.5C6.5 9.44 8.06 11 10 11C11.94 11 13.5 9.44 13.5 7.5C13.5 5.56 11.94 4 10 4ZM10 9C9.17 9 8.5 8.33 8.5 7.5C8.5 6.67 9.17 6 10 6C10.83 6 11.5 6.67 11.5 7.5C11.5 8.33 10.83 9 10 9Z"
    />
  </svg>
);

const Bag: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="16"
    height="20"
    viewBox="0 0 16 20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14 4H12C12 1.79 10.21 0 8 0C5.79 0 4 1.79 4 4H2C0.9 4 0 4.9 0 6V18C0 19.1 0.9 20 2 20H14C15.1 20 16 19.1 16 18V6C16 4.9 15.1 4 14 4ZM8 2C9.1 2 10 2.9 10 4H6C6 2.9 6.9 2 8 2ZM14 18H2V6H4V8C4 8.55 4.45 9 5 9C5.55 9 6 8.55 6 8V6H10V8C10 8.55 10.45 9 11 9C11.55 9 12 8.55 12 8V6H14V18Z"
    />
  </svg>
);

const Tag: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <path
        d="M21.41 11.58L12.41 2.58C12.05 2.22 11.55 2 11 2H4C2.9 2 2 2.9 2 4V11C2 11.55 2.22 12.05 2.59 12.42L11.59 21.42C11.95 21.78 12.45 22 13 22C13.55 22 14.05 21.78 14.41 21.41L21.41 14.41C21.78 14.05 22 13.55 22 13C22 12.45 21.77 11.94 21.41 11.58ZM13 20.01L4 11V4H11V3.99L20 12.99L13 20.01V20.01Z"
      />
      <path
        d="M6.5 8C7.32843 8 8 7.32843 8 6.5C8 5.67157 7.32843 5 6.5 5C5.67157 5 5 5.67157 5 6.5C5 7.32843 5.67157 8 6.5 8Z"
      />
      <path
        d="M8.8999 12.55C8.8999 13.12 9.1299 13.62 9.4999 14L12.9999 17.5L16.4999 14C16.8699 13.63 17.0999 13.11 17.0999 12.55C17.0999 11.42 16.1799 10.5 15.0499 10.5C14.4799 10.5 13.9699 10.73 13.5999 11.1L12.9999 11.7L12.3999 11.11C12.0299 10.73 11.5099 10.5 10.9499 10.5C9.8199 10.5 8.8999 11.42 8.8999 12.55Z"
      />
    </g>
  </svg>
);

const Document: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.17 2L16 6.83V16H2V2H11.17ZM11.17 0H2C0.9 0 0 0.9 0 2V16C0 17.1 0.9 18 2 18H16C17.1 18 18 17.1 18 16V6.83C18 6.3 17.79 5.79 17.41 5.42L12.58 0.59C12.21 0.21 11.7 0 11.17 0ZM4 12H14V14H4V12ZM4 8H14V10H4V8ZM4 4H11V6H4V4Z"
    />
  </svg>
);

const Clip: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="20"
    height="22"
    viewBox="0 0 20 22"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2 4H4V7H14V4H16V9H18V4C18 2.9 17.1 2 16 2H11.82C11.4 0.84 10.3 0 9 0C7.7 0 6.6 0.84 6.18 2H2C0.9 2 0 2.9 0 4V18C0 19.1 0.9 20 2 20H7V18H2V4ZM9 2C9.55 2 10 2.45 10 3C10 3.55 9.55 4 9 4C8.45 4 8 3.55 8 3C8 2.45 8.45 2 9 2Z"
    />
    <path
      d="M17.3 17.9C17.7 17.2 18 16.4 18 15.5C18 13 16 11 13.5 11C11 11 9 13 9 15.5C9 18 11 20 13.5 20C14.4 20 15.2 19.7 15.9 19.3L18.6 22L20 20.6L17.3 17.9ZM13.5 18C12.1 18 11 16.9 11 15.5C11 14.1 12.1 13 13.5 13C14.9 13 16 14.1 16 15.5C16 16.9 14.9 18 13.5 18Z"
    />
  </svg>
);

const Check: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="18"
    height="14"
    viewBox="0 0 18 14"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M6.00003 11.17L1.83003 7L0.410034 8.41L6.00003 14L18 2L16.59 0.589996L6.00003 11.17Z" />
  </svg>
);

const Close: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.9998 1.41L12.5898 0L6.99976 5.59L1.40976 0L-0.000244141 1.41L5.58976 7L-0.000244141 12.59L1.40976 14L6.99976 8.41L12.5898 14L13.9998 12.59L8.40976 7L13.9998 1.41Z"
    />
  </svg>
);

const Flash: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="11"
    height="18"
    viewBox="0 0 11 18"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.99997 18H2.99997L3.99997 11H0.499971C-0.380029 11 0.169971 10.25 0.189971 10.22C1.47997 7.94 3.41997 4.54 6.00997 0H7.00997L6.00997 7H9.51997C9.91997 7 10.14 7.19 9.91997 7.66C5.96997 14.55 3.99997 18 3.99997 18Z"
    />
  </svg>
);

const Edit: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <path
        d="M14.06 9.02L14.98 9.94L5.92 19H5V18.08L14.06 9.02ZM17.66 3C17.41 3 17.15 3.1 16.96 3.29L15.13 5.12L18.88 8.87L20.71 7.04C21.1 6.65 21.1 6.02 20.71 5.63L18.37 3.29C18.17 3.09 17.92 3 17.66 3ZM14.06 6.19L3 17.25V21H6.75L17.81 9.94L14.06 6.19Z"
      />
    </g>
  </svg>
);

const Messages: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <path
        d="M17 6V13H7.17L6.58 13.59L6 14.17V6H17ZM18 4H5C4.45 4 4 4.45 4 5V19L8 15H18C18.55 15 19 14.55 19 14V5C19 4.45 18.55 4 18 4ZM23 8H21V17H8V19C8 19.55 8.45 20 9 20H20L24 24V9C24 8.45 23.55 8 23 8Z"
      />
    </g>
  </svg>
);

const UnreadMessages: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <path
        d="M17 6V13H7.17L6.58 13.59L6 14.17V6H17ZM18 4H5C4.45 4 4 4.45 4 5V19L8 15H18C18.55 15 19 14.55 19 14V5C19 4.45 18.55 4 18 4ZM23 8H21V17H8V19C8 19.55 8.45 20 9 20H20L24 24V9C24 8.45 23.55 8 23 8Z"
      />
    </g>
    <circle
      cx="4.5"
      cy="4.5"
      r="4.5"
      fill="#E87324"
    />
  </svg>
);

const DropdownArrow: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="12"
    height="8"
    viewBox="0 0 12 8"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M1.41 0.59L6 5.17L10.59 0.59L12 2L6 8L0 2L1.41 0.59Z" />
  </svg>
);

const Plus: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14 8H8V14H6V8H0V6H6V0H8V6H14V8Z"
    />
  </svg>
);

const Lock: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="16"
    height="21"
    viewBox="0 0 16 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M14 7H13V5C13 2.24 10.76 0 8 0C5.24 0 3 2.24 3 5V7H2C0.9 7 0 7.9 0 9V19C0 20.1 0.9 21 2 21H14C15.1 21 16 20.1 16 19V9C16 7.9 15.1 7 14 7ZM5 5C5 3.34 6.34 2 8 2C9.66 2 11 3.34 11 5V7H5V5ZM14 19H2V9H14V19ZM8 16C9.1 16 10 15.1 10 14C10 12.9 9.1 12 8 12C6.9 12 6 12.9 6 14C6 15.1 6.9 16 8 16Z" />
  </svg>
);

const Date: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="21"
    height="22"
    viewBox="0 0 21 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M20.91 2.00024H17.91V0.000244141H15.91V2.00024H5.91003V0.000244141H3.91003V2.00024H0.910034V22.0002H20.91V2.00024ZM18.91 20.0002H2.91003V7.00024H18.91V20.0002Z" />
  </svg>
);

const Delete: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="14"
    height="18"
    viewBox="0 0 14 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M11 6V16H3V6H11ZM9.5 0H4.5L3.5 1H0V3H14V1H10.5L9.5 0ZM13 4H1V16C1 17.1 1.9 18 3 18H11C12.1 18 13 17.1 13 16V4Z" />
  </svg>
);

const Store: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="18"
    height="16"
    viewBox="0 0 18 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M15.36 5L15.96 8H2.04L2.64 5H15.36ZM17 0H1V2H17V0ZM17 3H1L0 8V10H1V16H11V10H15V16H17V10H18V8L17 3ZM3 14V10H9V14H3Z" />
  </svg>
);

const Expand: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="10"
    height="18"
    viewBox="0 0 10 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M5 18.0001L0.5 13.5001L1.6 12.4001L5 15.8001L8.4 12.4001L9.5 13.5001L5 18.0001ZM1.6 5.7001L0.5 4.6001L5 0.100098L9.5 4.6001L8.4 5.7001L5 2.3001L1.6 5.7001Z" />
  </svg>
);

const Collapse: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="10"
    height="16"
    viewBox="0 0 10 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M1.575 16L0.5 14.925L5 10.425L9.5 14.925L8.425 16L5 12.575L1.575 16ZM5 5.575L0.5 1.075L1.575 0L5 3.425L8.425 0L9.5 1.075L5 5.575Z" />
  </svg>
);

const Refresh: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="16"
    height="20"
    viewBox="0 0 16 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M8 4V0L3 5L8 10V6C11.31 6 14 8.69 14 12C14 15.31 11.31 18 8 18C4.69 18 2 15.31 2 12H0C0 16.42 3.58 20 8 20C12.42 20 16 16.42 16 12C16 7.58 12.42 4 8 4Z" />
  </svg>
);

const Info: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M18 10H22V14H18V10ZM18 18H22V30H18V18ZM20 0C8.96 0 0 8.96 0 20C0 31.04 8.96 40 20 40C31.04 40 40 31.04 40 20C40 8.96 31.04 0 20 0ZM20 36C11.18 36 4 28.82 4 20C4 11.18 11.18 4 20 4C28.82 4 36 11.18 36 20C36 28.82 28.82 36 20 36Z" />
  </svg>
);

const Dashboard: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="19"
    height="18"
    viewBox="0 0 19 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M16.3872 2V4H12.3872V2H16.3872ZM6.38721 2V8H2.38721V2H6.38721ZM16.3872 10V16H12.3872V10H16.3872ZM6.38721 14V16H2.38721V14H6.38721ZM18.3872 0H10.3872V6H18.3872V0ZM8.38721 0H0.387207V10H8.38721V0ZM18.3872 8H10.3872V18H18.3872V8ZM8.38721 12H0.387207V18H8.38721V12Z" />
  </svg>
);

const MenuDots: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="4"
    height="16"
    viewBox="0 0 4 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2 4C3.1 4 4 3.1 4 2C4 0.9 3.1 0 2 0C0.9 0 0 0.9 0 2C0 3.1 0.9 4 2 4ZM2 6C0.9 6 0 6.9 0 8C0 9.1 0.9 10 2 10C3.1 10 4 9.1 4 8C4 6.9 3.1 6 2 6ZM2 12C0.9 12 0 12.9 0 14C0 15.1 0.9 16 2 16C3.1 16 4 15.1 4 14C4 12.9 3.1 12 2 12Z"
    />
  </svg>
);

const Branch: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="18"
    height="22"
    viewBox="0 0 18 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M18 19C18 19.8333 17.7083 20.5417 17.125 21.125C16.5417 21.7083 15.8333 22 15 22C14.1667 22 13.4583 21.7083 12.875 21.125C12.2917 20.5417 12 19.8333 12 19C12 18.8167 12.0167 18.6333 12.05 18.45C12.0833 18.2667 12.1333 18.0833 12.2 17.9L6.725 13.9C6.35833 14.2333 5.94583 14.5 5.4875 14.7C5.02917 14.9 4.53333 15 4 15C2.9 15 1.95833 14.6083 1.175 13.825C0.391666 13.0417 -4.32743e-07 12.1 -4.80825e-07 11C-5.28908e-07 9.9 0.391666 8.95833 1.175 8.175C1.95833 7.39167 2.9 7 4 7C4.53333 7 5.02917 7.1 5.4875 7.3C5.94583 7.5 6.35833 7.76667 6.725 8.1L12.225 4.1C12.1417 3.91667 12.0833 3.7375 12.05 3.5625C12.0167 3.3875 12 3.2 12 3C12 2.16667 12.2917 1.45833 12.875 0.874999C13.4583 0.291665 14.1667 -6.19245e-07 15 -6.55671e-07C15.8333 -6.92097e-07 16.5417 0.291665 17.125 0.874999C17.7083 1.45833 18 2.16667 18 3C18 3.83333 17.7083 4.54167 17.125 5.125C16.5417 5.70833 15.8333 6 15 6C14.6333 6 14.2917 5.9375 13.975 5.8125C13.6583 5.6875 13.3667 5.51667 13.1 5.3L7.625 9.3C7.70833 9.45 7.77083 9.60417 7.8125 9.7625C7.85417 9.92083 7.89167 10.0833 7.925 10.25L12.1 10.25C12.2667 9.6 12.6167 9.0625 13.15 8.6375C13.6833 8.2125 14.3 8 15 8C15.8333 8 16.5417 8.29167 17.125 8.875C17.7083 9.45833 18 10.1667 18 11C18 11.8333 17.7083 12.5417 17.125 13.125C16.5417 13.7083 15.8333 14 15 14C14.3 14 13.6833 13.7875 13.15 13.3625C12.6167 12.9375 12.2667 12.4 12.1 11.75L7.925 11.75C7.89167 11.9167 7.85417 12.0792 7.8125 12.2375C7.77083 12.3958 7.70833 12.55 7.625 12.7L13.1 16.7C13.3667 16.4833 13.6583 16.3125 13.975 16.1875C14.2917 16.0625 14.6333 16 15 16C15.8333 16 16.5417 16.2917 17.125 16.875C17.7083 17.4583 18 18.1667 18 19ZM16.5 19C16.5 18.5667 16.3542 18.2083 16.0625 17.925C15.7708 17.6417 15.4167 17.5 15 17.5C14.5667 17.5 14.2083 17.6417 13.925 17.925C13.6417 18.2083 13.5 18.5667 13.5 19C13.5 19.4167 13.6417 19.7708 13.925 20.0625C14.2083 20.3542 14.5667 20.5 15 20.5C15.4167 20.5 15.7708 20.3542 16.0625 20.0625C16.3542 19.7708 16.5 19.4167 16.5 19ZM16.5 11C16.5 10.5667 16.3542 10.2083 16.0625 9.925C15.7708 9.64167 15.4167 9.5 15 9.5C14.5667 9.5 14.2083 9.64167 13.925 9.925C13.6417 10.2083 13.5 10.5667 13.5 11C13.5 11.4167 13.6417 11.7708 13.925 12.0625C14.2083 12.3542 14.5667 12.5 15 12.5C15.4167 12.5 15.7708 12.3542 16.0625 12.0625C16.3542 11.7708 16.5 11.4167 16.5 11ZM16.5 3C16.5 2.56667 16.3542 2.20833 16.0625 1.925C15.7708 1.64167 15.4167 1.5 15 1.5C14.5667 1.5 14.2083 1.64167 13.925 1.925C13.6417 2.20833 13.5 2.56667 13.5 3C13.5 3.41667 13.6417 3.77083 13.925 4.0625C14.2083 4.35417 14.5667 4.5 15 4.5C15.4167 4.5 15.7708 4.35417 16.0625 4.0625C16.3542 3.77083 16.5 3.41667 16.5 3ZM6.5 11C6.5 10.3 6.25833 9.70833 5.775 9.225C5.29167 8.74167 4.7 8.5 4 8.5C3.3 8.5 2.70833 8.74167 2.225 9.225C1.74167 9.70833 1.5 10.3 1.5 11C1.5 11.7 1.74167 12.2917 2.225 12.775C2.70833 13.2583 3.3 13.5 4 13.5C4.7 13.5 5.29167 13.2583 5.775 12.775C6.25833 12.2917 6.5 11.7 6.5 11Z" />
  </svg>
);

const Copy: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="20"
    height="22"
    viewBox="0 0 20 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M14.5 0H2.5C1.4 0 0.5 0.9 0.5 2V16H2.5V2H14.5V0ZM17.5 4H6.5C5.4 4 4.5 4.9 4.5 6V20C4.5 21.1 5.4 22 6.5 22H17.5C18.6 22 19.5 21.1 19.5 20V6C19.5 4.9 18.6 4 17.5 4ZM17.5 20H6.5V6H17.5V20Z" />
  </svg>
);

const Filters: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="18"
    height="12"
    viewBox="0 0 18 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M7 12V10H11V12H7ZM0 2V0H18V2H0ZM3 7V5H15V7H3Z" />
  </svg>
);

const Search: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M20.8333 18.3333H19.5167L19.05 17.8833C20.6833 15.9833 21.6667 13.5167 21.6667 10.8333C21.6667 4.85 16.8167 0 10.8333 0C4.85 0 0 4.85 0 10.8333C0 16.8167 4.85 21.6667 10.8333 21.6667C13.5167 21.6667 15.9833 20.6833 17.8833 19.05L18.3333 19.5167V20.8333L26.6667 29.15L29.15 26.6667L20.8333 18.3333ZM10.8333 18.3333C6.68333 18.3333 3.33333 14.9833 3.33333 10.8333C3.33333 6.68333 6.68333 3.33333 10.8333 3.33333C14.9833 3.33333 18.3333 6.68333 18.3333 10.8333C18.3333 14.9833 14.9833 18.3333 10.8333 18.3333Z" />
  </svg>
);

const Link: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="16"
    height="18"
    viewBox="0 0 16 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M13 12.4C12.3667 12.4 11.8 12.65 11.3667 13.0417L5.425 9.58335C5.46667 9.39169 5.5 9.20002 5.5 9.00002C5.5 8.80002 5.46667 8.60835 5.425 8.41669L11.3 4.99169C11.75 5.40835 12.3417 5.66669 13 5.66669C14.3833 5.66669 15.5 4.55002 15.5 3.16669C15.5 1.78335 14.3833 0.666687 13 0.666687C11.6167 0.666687 10.5 1.78335 10.5 3.16669C10.5 3.36669 10.5333 3.55835 10.575 3.75002L4.7 7.17502C4.25 6.75835 3.65833 6.50002 3 6.50002C1.61667 6.50002 0.5 7.61669 0.5 9.00002C0.5 10.3834 1.61667 11.5 3 11.5C3.65833 11.5 4.25 11.2417 4.7 10.825L10.6333 14.2917C10.5917 14.4667 10.5667 14.65 10.5667 14.8334C10.5667 16.175 11.6583 17.2667 13 17.2667C14.3417 17.2667 15.4333 16.175 15.4333 14.8334C15.4333 13.4917 14.3417 12.4 13 12.4Z" />
  </svg>
);

const PlusBlock: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M2 18C1.45 18 0.979167 17.8042 0.5875 17.4125C0.195833 17.0208 0 16.55 0 16V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H8V2H2V16H16V10H18V16C18 16.55 17.8042 17.0208 17.4125 17.4125C17.0208 17.8042 16.55 18 16 18H2ZM13 8V5H10V3H13V0H15V3H18V5H15V8H13Z" />
  </svg>
);

const Stars: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="20"
    height="18"
    viewBox="0 0 20 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M7.6 11.575L8.85198 8.85197L11.575 7.6L8.85198 6.34802L7.6 3.625L6.34802 6.34802L3.625 7.6L6.34802 8.85197L7.6 11.575ZM7.6 15.2L5.225 9.975L0 7.6L5.225 5.225L7.6 0L9.975 5.225L15.2 7.6L9.975 9.975L7.6 15.2ZM16.2 18L15.025 15.375L12.4 14.2L15.025 13L16.2 10.4L17.4 13L20 14.2L17.4 15.375L16.2 18Z" />
  </svg>
);

const Invalid: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M7.00016 0.333252C3.3135 0.333252 0.333496 3.31325 0.333496 6.99992C0.333496 10.6866 3.3135 13.6666 7.00016 13.6666C10.6868 13.6666 13.6668 10.6866 13.6668 6.99992C13.6668 3.31325 10.6868 0.333252 7.00016 0.333252ZM7.00016 12.3333C4.06016 12.3333 1.66683 9.93992 1.66683 6.99992C1.66683 4.05992 4.06016 1.66659 7.00016 1.66659C9.94016 1.66659 12.3335 4.05992 12.3335 6.99992C12.3335 9.93992 9.94016 12.3333 7.00016 12.3333ZM9.3935 3.66659L7.00016 6.05992L4.60683 3.66659L3.66683 4.60659L6.06016 6.99992L3.66683 9.39325L4.60683 10.3333L7.00016 7.93992L9.3935 10.3333L10.3335 9.39325L7.94016 6.99992L10.3335 4.60659L9.3935 3.66659Z" />
  </svg>
);

const ArrowLeft: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M8 0L9.41 1.41L3.83 7H16V9H3.83L9.41 14.59L8 16L0 8L8 0Z" />
  </svg>
);

const ArrowRight: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M8 16L6.59 14.59L12.17 9L1.22392e-06 9L1.57361e-06 7L12.17 7L6.59 1.41L8 1.39876e-06L16 8L8 16Z" />
  </svg>

);

const icons: any = {
  Profile,
  Bag,
  Tag,
  Document,
  Clip,
  Check,
  Close,
  Flash,
  Edit,
  Messages,
  UnreadMessages,
  DropdownArrow,
  Plus,
  Lock,
  Date,
  Delete,
  Store,
  Expand,
  Collapse,
  Refresh,
  Info,
  Dashboard,
  MenuDots,
  Branch,
  Copy,
  Filters,
  Search,
  Link,
  PlusBlock,
  Stars,
  Invalid,
  ArrowLeft,
  ArrowRight,
};

export default icons;
